import React from 'react';
import { useDispatch } from 'react-redux';
import useActions from 'hooks/useActions';
import { i18n } from 'utils/i18n';
import { ANALYTICS, MODAL_BUTTON_TYPES, MODAL } from 'constants';
import { selectCarClass } from 'actions/reservation/selectCarClass';
import { openModal } from 'actions/modal/openModal';
import { ModalFooter } from 'components/Modal/ModalFooter';
import propTypes from './limitedInventoryVehicleModalContentPropTypes';

const { ACCEPT, DECLINE } = MODAL_BUTTON_TYPES;

const LimitedInventoryVehicleModalContent = ({
  code,
  prepay,
  description,
  handleClose,
  isTermsAndConditionsRequired,
}) => {
  const dispatch = useDispatch();
  const showTermsOfUseVanModal = useActions(() =>
    openModal(MODAL.VAN_SELECTED_12_AND_15_TERMS_USE, { props: { code, description, prepay } })
  );

  const handleAccept = () => {
    // On 'Continue' CTA - If 'isTermsAndConditionsRequired(props.vehicle?.terms_and_conditions_required)' is true,
    // User then sees 'Terms of Use modal' for passenger vans
    if (isTermsAndConditionsRequired) {
      showTermsOfUseVanModal(code, description, prepay);
    } else {
      dispatch(selectCarClass({ code, prepay }));
    }

    handleClose({
      analyticsValue: ANALYTICS.CONTINUE_With(code),
    });
  };

  return (
    <>
      <p>{i18n('limited_inventory_vehicle_modal_content')}</p>
      <ModalFooter
        buttons={[
          {
            type: DECLINE,
            label: i18n('limited_inventory_modal_decline'),
            analyticsValue: ANALYTICS.CHANGE_SELECTION,
          },
          {
            type: ACCEPT,
            label: i18n('limited_inventory_modal_accept'),
            handler: handleAccept,
          },
        ]}
      />
    </>
  );
};

LimitedInventoryVehicleModalContent.propTypes = propTypes;

export default LimitedInventoryVehicleModalContent;
